import React, { useState, useEffect } from 'react';

// Libs
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useSelector } from 'react-redux';
import { useNodeId } from '@xyflow/react';

// Hooks
import { useNodeUpdate } from '~/hooks/useNodeUpdate';

// Utilitários
import { NodeHeaderCustomDeleteAction } from '~/utils/NodeHeaderCustomDeleteAction';
import { NodeHeaderCustomAlertAction } from '~/utils/NodeHeaderCustomAlertAction';
import { CustomDDVariavel } from '~/utils/CustomDDVariavel';
import { CustomInputDrop } from '~/utils/CustomInputDrop';
import { CustomHandle } from '~/utils/CustomHandle';

// Node de atribuição
// Este componente permite que o usuário atribua um valor a uma variável
// Ele possui um campo para selecionar a variável e outro para definir o valor a ser atribuído
// O usuário pode arrastar e soltar variáveis ou expressões para definir o valor
// O nó também verifica pendências, como se a variável e o valor estão preenchidos corretamente
export const AtribuirNode = ({ data }) => {
    const id = useNodeId();
    const { onNodesChange } = useNodeUpdate();
    const variaveis = useSelector((state) => state.variaveis);
    const [variavel, setVariavel] = useState(data.variavel || '');
    const [dropData, setDropData] = useState(data.dropData || { id: 'value', type: null, data: {} });
    const [listaPendencias, setListaPendencias] = useState([]);

    // Sync on undo/redo
    useEffect(() => { setVariavel(data.variavel || ''); }, [data.variavel]);
    useEffect(() => { setDropData(data.dropData || { id: 'value', type: null, data: {} }); }, [data.dropData]);

    const handleVariavelChange = (v) => {
        setVariavel(v);
        onNodesChange([{ id, type: 'update', data: { variavel: v } }]);
    };
    const handleDropChange = (newDrop) => {
        setDropData(newDrop);
        onNodesChange([{ id, type: 'update', data: { dropData: newDrop } }]);
    };

    const conferePendencias = () => {
        const pendencias = [];
        if (!variavel) pendencias.push('Variável não selecionada');
        if (!dropData.type && !dropData.data.value) pendencias.push('Valor não preenchido');
        setListaPendencias(pendencias);
        return pendencias;
    };

    useEffect(() => { conferePendencias(); }, [variavel, dropData]);

    return (
        <div className="node node-mostrar">
            <div className="titulo-node">
                <FontAwesomeIcon icon="fa-solid fa-folder-open" />
                {data.label.toUpperCase()}
            </div>
            <div className="linha-separadora" />
            <div className="node-geral">
                <div className="node-botoes">
                    <button title="Executar este comando" onClick={() => alert('Executar')}>
                        <FontAwesomeIcon icon="fa-solid fa-circle-play" />
                    </button>
                    <NodeHeaderCustomDeleteAction />
                    {listaPendencias.length > 0 && <NodeHeaderCustomAlertAction conferePendencias={conferePendencias} nodeData={data} />}
                </div>
                <div className="node-principal" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '8px' }}>
                    <CustomDDVariavel variaveis={variaveis} value={variavel} onChange={handleVariavelChange} />
                    <FontAwesomeIcon icon="fa-solid fa-arrow-down" style={{ color: '#555', fontSize: '20px' }} />
                    <CustomInputDrop dropData={dropData} dropId="value" onDropChange={handleDropChange} />
                    <CustomHandle type="target" position="top" connectionCount={1} allowLoopConnections={true} />
                    <CustomHandle type="source" position="bottom" connectionCount={1} />
                </div>
            </div>
        </div>
    );
};
